<template>
	<div class="page">
		<div class="">
			<div class="" style="display: flex; align-items: center;margin-top: 1.25rem;">
				<span style="color: #606266;font-size: 0.875rem;">当前位置：</span>
				<el-breadcrumb separator-class="el-icon-arrow-right" style="">
					<el-breadcrumb-item>首页</el-breadcrumb-item>
					<el-breadcrumb-item>签证资讯</el-breadcrumb-item>
					<el-breadcrumb-item>资讯详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			
			<div class="main_title">
				{{ data.NewsTitle }}
			</div>
			
			<div class="main_time">
				<i class="el-icon-time"></i>
				{{data.CreateTime}}
			</div>
			
			<div class="main_content" v-html="data.NewsContent">
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: '',
				data: []
			};
		},
		created() {
			let {
				id
			} = this.$route.query
			this.id = id;
			this.GetNewsDetails()
		},
		methods: {
			GetNewsDetails() {
				this.$api.GetNewsDetails({
					Id: this.id
				}).then(res => {
					let {
						data,
						result
					} = res.data
					console.log(res.data)
					if (result) {
						const timestamp = parseInt(data.CreateTime.match(/\d+/)[0])
						const date = new Date(timestamp)
						const formattedTime =
							`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
						data.CreateTime = formattedTime
						this.data = data
					} else {

					}
				})
			},
		}
	}
</script>

<style lang='less' scoped>
	.page {
		text-align: initial !important;
		background-color: #fff;		
		&>div {
			overflow: hidden;
			/* width: 1080px; */
			width: 900px;
			height: auto;
			margin: 0 auto;
			background-color: #fff;				
			.main_title{
				font-weight: 600;
				font-size: 1.5rem;
				margin-top: 4.375rem;
			}
			.main_time{
				font-size: 0.875rem;
				color: #999;
				margin-top: 2.5rem;
				padding-bottom: 1.25rem;
				border-bottom: 1px solid #eee;
			}

			.main_content{
				line-height: 30px;
				font-size:18px;		
				padding-bottom: 30px;						
			}
		}
	}
</style>
<style>
h1{
	padding:10px 0;
	line-height: 50px;
}
h2,h3{
	padding:10px 0;
}
</style>



// WEBPACK FOOTER //
// src/page/news/newsdetails.vue